import { defaultItems } from '../recoil-store/recoil-state';

/**
 * @description This function lets you return flow history.
 * @returns     History
 * @author      ibrahim AKIN
 */
export const history = {
    past: [],
    present: defaultItems,
    future: []
}

export const errorFlowHistories = {}

export const handleUndo = (type = "history", id) => {
    if (type === "history") {
        let present = history.past.pop();
        if (present) {
            history.future.push(JSON.parse(JSON.stringify(history.present)));
            history.present = JSON.parse(JSON.stringify(present));
            return present;
        }
    } else {
        if (!errorFlowHistories[id]) {
            createErrorHistory(id, JSON.parse(JSON.stringify(defaultItems)))
        }
        let present = errorFlowHistories[id].past.pop();
        if (present) {
            errorFlowHistories[id].future.push(JSON.parse(JSON.stringify(errorFlowHistories[id].present)));
            errorFlowHistories[id].present = JSON.parse(JSON.stringify(present));
            return present;
        }
    }

}

export const handleRedo = (type = "history", id) => {
    if (type === "history") {
        let present = history.future.pop();
        if (present) {
            history.past.push(JSON.parse(JSON.stringify(history.present)));
            history.present = JSON.parse(JSON.stringify(present));
            return present;
        }
    } else {
        if (!errorFlowHistories[id]) {
            createErrorHistory(id, JSON.parse(JSON.stringify(defaultItems)))
        }
        let present = errorFlowHistories[id].future.pop();
        if (present) {
            errorFlowHistories[id].past.push(JSON.parse(JSON.stringify(errorFlowHistories[id].present)));
            errorFlowHistories[id].present = JSON.parse(JSON.stringify(present));
            return present;
        }
    }
}

export const handleUpdate = (present, clear, initial, type = "history", id) => {
    if (type === "history") {
        if (present) {
            if (history.past.length > 30) {
                history.past.shift();
            }
            history.past.push(JSON.parse(JSON.stringify(history.present)));
            history.present = JSON.parse(JSON.stringify(present));
            history.future = [];
        }
        else if (clear) {
            history.past = []
            if (initial) {
                history.present = initial
            }
            history.future = [];
        }
    } else {
        if (!errorFlowHistories[id]) {
            createErrorHistory(id, JSON.parse(JSON.stringify(defaultItems)))
        }
        if (present) {
            if (errorFlowHistories[id].past.length > 30) {
                errorFlowHistories[id].past.shift();
            }
            errorFlowHistories[id].past.push(JSON.parse(JSON.stringify(errorFlowHistories[id].present)));
            errorFlowHistories[id].present = JSON.parse(JSON.stringify(present));
            errorFlowHistories[id].future = [];
        }
        else if (clear) {
            errorFlowHistories[id].past = []
            if (initial) {
                errorFlowHistories[id].present = initial
            }
            errorFlowHistories[id].future = [];
        }
    }
}

export const handleInit = (initial, type = "history", id) => {
    if (type === "history") {
        history.present = initial;
    } else {
        if (!errorFlowHistories[id]) {
            createErrorHistory(id, JSON.parse(JSON.stringify(defaultItems)))
        }
        errorFlowHistories[id].present = initial;
    }

}


export const createErrorHistory = (id, initial) => {
    errorFlowHistories[id] = {
        past: [],
        present: initial ? initial : [],
        future: []
    }
}